import React from "react";
import { Link } from "react-router-dom";
import { Construction } from "lucide-react";

/**
 * Generic admin placeholder used when a sidebar item maps to a route that
 * doesn't yet have a top-level admin view (e.g. cross-tenant Playbooks /
 * Project Tracker). These screens still exist per-tenant inside the
 * customer workspace.
 */
export default function AdminPlaceholder({ title, subtitle, backTo = "/app" }) {
  return (
    <div className="max-w-2xl mx-auto py-16" data-testid={`admin-placeholder-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <div
        className="rounded-2xl border bg-white p-10 text-center"
        style={{ borderColor: "rgba(0,0,0,0.08)" }}
      >
        <div
          className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full"
          style={{ background: "rgba(59,79,228,0.10)", color: "#3B4FE4" }}
        >
          <Construction className="h-6 w-6" />
        </div>
        <h2 className="text-[22px] font-bold tracking-tight" style={{ color: "#0F1117" }}>
          {title}
        </h2>
        {subtitle && (
          <p className="mt-2 text-[14px] max-w-md mx-auto" style={{ color: "#5C6070" }}>
            {subtitle}
          </p>
        )}
        <Link
          to={backTo}
          className="inline-flex items-center justify-center mt-6 px-5 py-2.5 rounded-[10px] text-[14px] font-semibold text-white transition-colors hover:opacity-90"
          style={{ backgroundColor: "#3B4FE4" }}
          data-testid="admin-placeholder-back"
        >
          Take me to Customers
        </Link>
      </div>
    </div>
  );
}
